import GridContainer from '@commonComponent/grid/gridContainer';
import GridElement from '@commonComponent/grid/gridElement';
import { Button } from '@componentLibraryWrapper/button';
import { deleteSessionAsync } from '@myRedux/session/sessionSlice';
import { SelectWithLabel } from '@commonComponent/input/selectWithLabel';
import { Box } from '@componentLibraryWrapper/box';
import { SelectChangeEvent } from '@componentLibraryWrapper/select';
import { MenuItem } from '@componentLibraryWrapper/menuItem';
import { useAppDispatch, useAppSelector } from '@myRedux/hooks';
import { selectTheme, setTheme } from '@myRedux/user/userSettingsSlice';
import { useTheme } from 'hooks/mui/useTheme';
import './userMenu.scss';

type UserMenuProps = {
  onLogout: () => void;
}

const UserMenu = ({
  onLogout
}: UserMenuProps) => {
  const dispatch = useAppDispatch();
	const themeSelector = useAppSelector(selectTheme);
  const theme = useTheme();

  function handleThemeChange(event: SelectChangeEvent<typeof themeSelector>) {
    dispatch(setTheme(event.target.value));
  }

  async function handleLogoutClick() {
		await dispatch(deleteSessionAsync())
    onLogout();
	}

  return (
    <GridElement
      xs={12}
      sm={8}
      md={6}
      lg={4}
      xl={3}
      id='usermenu-box'
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.default
        }}>
        <GridContainer>
          <GridElement
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className='usermenu'
          >
            <h2>USER MENU</h2>
            <SelectWithLabel
              fullWidth
              value={themeSelector}
              label='Theme'
              labelId='select-theme'
              onChange={handleThemeChange}
            >
              <MenuItem
                value={'light'}>
                Light
              </MenuItem>
              <MenuItem
                value={'dark'}>
                Dark
              </MenuItem>
            </SelectWithLabel>
            <GridContainer>
              <GridElement
                xs={6}
              >
                <Box
                  display='flex'
                  justifyContent='left'
                >
                  <Button
                    href='user'
                    variant='outlined'
                  >
                    Settings
                  </Button>
                </Box>
              </GridElement>
              <GridElement
                xs={6}
              >
                <Box
                  display='flex'
                  justifyContent='right'
                >
                  <Button
                    color='error'
                    onClick={handleLogoutClick}
                    variant='contained'>
                    Logout
                  </Button>
                </Box>
              </GridElement>
            </GridContainer>
          </GridElement>
        </GridContainer>
      </Box>
    </GridElement>
  );
}

export default UserMenu;